<app-light-bottom-svg></app-light-bottom-svg>
<div class="container-fluid bg-gray text-light">
  <div class="animate-to-top row text-center">
    <div class="col-12 mt-5">
      <h1 class="horizontal-line"><span class="bg-gray px-3">Hey!!!</span></h1>
    </div>
  </div>
  <div class="animate-to-top row mt-4">
    <div class="pl-md-5 col-12 col-md-6">
      <div><h2>Contact me here</h2></div>
      <div class="pl-md-3 pl-lg-4 row mb-3">
        <div class="col-1 text-center">
          <i class="mt-3 map-mark fa fa-map-marker" aria-hidden="true"></i>
        </div>
        <div class="col-10 col-md-10 col-lg-8">
          <span
            >31, Chamunda Apartment Balgarh road, sarkari nursery ke samne,
            Dewas, M.P.,INDIA, 455001</span
          >
        </div>
      </div>
      <div class="pl-md-3 pl-lg-4 row mb-3">
        <div class="col-1 text-center">
          <i class="envelop fa fa-envelope" aria-hidden="true"></i>
        </div>
        <div class="col-10 col-md-7 col-lg-5">
          <span>sumantmishra511@gmail.com</span>
        </div>
      </div>
      <div class="pl-md-3 pl-lg-4 row mb-3">
        <div class="col-1 text-center">
          <i class="mobile fa fa-mobile" aria-hidden="true"></i>
        </div>
        <div class="col-10 col-md-7 col-lg-5">
          <span>+91 9579310997</span>
        </div>
      </div>
      <div class="pl-md-3 pl-lg-4 row mb-3">
        <div class="col-1 text-center">
          <i class="globe fa fa-globe" aria-hidden="true"></i>
        </div>
        <div class="col-10 col-md-7 col-lg-5">
          <a href="https://sumant-portfolio.netlify.app/" target="blank"
            >www.sumant-mishra.netlify.com</a
          >
        </div>
      </div>
    </div>
    <div class="pt-0 pr-md-5 col-12 col-md-6">
      <div>
        <div><h2>Get In Touch</h2></div>
        <form [formGroup]="contactForm">
          <div class="form-group">
            <input
              type="text"
              formControlName="name"
              class="bg-transparent text-light shadow-none border rounded-0 h-auto form-control"
              placeholder="Enter your name"
            />
          </div>
          <div class="form-group">
            <input
              type="email"
              formControlName="email"
              class="bg-transparent text-light shadow-none border rounded-0 h-auto form-control"
              placeholder="Enter your email"
            />
          </div>
          <div class="form-group">
            <textarea
              formControlName="message"
              placeholder="Enter your message here..."
              class="bg-transparent text-light shadow-none border rounded-0 h-auto form-control"
              rows="3"
            ></textarea>
          </div>
          <button
            (click)="submitMessage()"
            type="button"
            class="float-right text-light mb-5 bg-transparent text-light shadow-none border rounded-0 h-auto btn"
          >
            Let me know
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
